import React from 'react'
import { Box, Button, Dialog, Slide, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getColorSpecialByTheme, variantStyles } from '~/theme/constants'
import { path } from '~/routes/path'
import { selectRestaurant } from '~/redux/restaurantSlice'
import { isOnlinePayment } from '~/utils'
import { useThemeContext } from '~/theme/ThemeProvider'

const PopupPayment = ({ onClosePopup, onConfirm, open }) => {
  const { currentThemeObject } = useThemeContext()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { extraFeatures } = useSelector(selectRestaurant)
  const isSettingOnlinePayment = isOnlinePayment(extraFeatures)

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />
  })

  // Di chuyển đến màn hình chọn phương thức thanh toán
  const goToChoosePaymentMethod = () => {
    navigate(path.choosePaymentMethod)
  }

  // Hiển thị nút pay online
  const renderPayOnlineBtn = () => {
    return (
      <Button
        variant={variantStyles.btnAddToOrder}
        style={styles.btnCommon}
        onClick={goToChoosePaymentMethod}>
        {t('actions.pay_online')}
      </Button>
    )
  }

  const renderDivide = () => {
    const color = currentThemeObject.colorText1

    return (
      <Box my="16px" display="flex" alignItems="center">
        <Box height="1px" bgcolor={color} flex={1} />
        <Box color={color} mx="8px" fontSize="1.8rem" fontWeight="500">
          {t('label.or')}
        </Box>
        <Box height="1px" bgcolor={color} flex={1} />
      </Box>
    )
  }

  const getBackgroundPayByCash = () => {
    if (isSettingOnlinePayment) return 'baseColor.colorText5'

    return 'baseColor.colorText1'
  }

  const getTextColorPayByCash = () => {
    if (isSettingOnlinePayment) return getColorSpecialByTheme(currentThemeObject.value)

    return 'baseColor.colorText2'
  }

  const renderPayByCashBtn = () => {
    return (
      <Button
        style={{ ...styles.btnCommon, border: `1px solid ${currentThemeObject.color2}` }}
        sx={{
          backgroundColor: getBackgroundPayByCash(),
          color: getTextColorPayByCash(),
          padding: '5px 16px',
        }}
        onClick={onConfirm}>
        {t('actions.ask_for_bill')}
      </Button>
    )
  }

  return (
    <>
      {open && (
        <Dialog
          style={styles.container}
          open={open}
          TransitionComponent={Transition}
          onClose={onClosePopup}
          aria-describedby="alert-dialog-slide-description"
          PaperProps={{
            style: styles.contentDialogCenter,
          }}>
          <Box style={styles.content} bgcolor="baseColor.color1">
            <Typography component="h2" style={styles.title} color="baseColor.colorText1">
              {t('titles.popup_pay')}
            </Typography>
            {isSettingOnlinePayment && (
              <>
                {renderPayOnlineBtn()}
                {renderDivide()}
              </>
            )}
            {renderPayByCashBtn()}
            <Typography component="p" style={styles.hintAction} color="baseColor.colorText1">
              {t('descriptions.popup_pay')}
            </Typography>
            <Box justifyContent="center" display="flex">
              <Button onClick={onClosePopup} style={styles.closeBtn}>
                <Typography
                  fontWeight="700"
                  fontSize="1.6rem"
                  color="baseColor.colorText1"
                  style={{ textDecoration: 'underline' }}>
                  {t('actions.not_yet')}
                </Typography>
              </Button>
            </Box>
          </Box>
        </Dialog>
      )}
    </>
  )
}

export default React.memo(PopupPayment)

PopupPayment.propTypes = {
  open: PropTypes.bool,
  onClosePopup: PropTypes.func,
  onConfirm: PropTypes.func,
}

const styles = {
  contentDialogCenter: {
    borderRadius: 15,
    border: '1px solid white',
  },
  container: {
    zIndex: 100,
  },
  content: {
    padding: '47px 44px 23px',

    borderRadius: 15,
  },
  title: { fontSize: '4.8rem', fontWeight: '600', lineHeight: '5rem', marginBottom: '50px' },
  btnCommon: {
    fontWeight: '600',
    fontSize: '2.2rem',
    width: '100%',
  },
  hintAction: {
    fontWeight: '600',
    lineHeight: '2rem',
    marginTop: 10,
  },
  closeBtn: {
    textAlign: 'center',
    marginTop: '14px',
    padding: '10px 0',
  },
}
